import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import React from "react";
type ContainerProps = {
  className?: string;
  innerClassName?: string;
  disablePadding?: boolean;
  content?: boolean;
  narrow?: boolean;
  children: React.ReactNode;
};
export const Container = t0 => {
  const $ = _c(23);
  let children;
  let narrow;
  let props;
  let ref;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      ref,
      className: t1,
      innerClassName: t2,
      disablePadding: t3,
      content: t4,
      children,
      narrow,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = narrow;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    children = $[1];
    narrow = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const className = t1 === undefined ? "" : t1;
  const innerClassName = t2 === undefined ? "" : t2;
  const disablePadding = t3 === undefined ? false : t3;
  t4 === undefined ? true : t4;
  let t5;
  if ($[9] !== className) {
    t5 = clsx("column relative w-full", className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = !disablePadding && "px-3 sm:px-6 lg:px-8";
  const t7 = narrow && "max-w-5xl px-3 sm:px-6 xl:px-0";
  let t8;
  if ($[11] !== innerClassName || $[12] !== t6 || $[13] !== t7) {
    t8 = clsx("column mx-auto flex max-w-7xl flex-col", t6, t7, innerClassName);
    $[11] = innerClassName;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== children || $[16] !== t8) {
    t9 = <div className={t8}>{children}</div>;
    $[15] = children;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== props || $[19] !== ref || $[20] !== t5 || $[21] !== t9) {
    t10 = <div className={t5} {...props} ref={ref}>{t9}</div>;
    $[18] = props;
    $[19] = ref;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
Container.displayName = "Container";